export default "__VITE_ASSET__1kwzqxp3__"